/*
 * Markizy do przeciągania (Społeczność, galerie w układzie „markiza",
 * tkaniny na telefonie).
 *
 * Pas ma w CSS zwykłą animację keyframes (tempo i kierunek zostają tam
 * jako konfiguracja). Ten skrypt ją WYŁĄCZA i sam przesuwa pas w rAF,
 * bo animacji CSS nie da się „złapać" palcem: nie ma jak odczytać
 * i przestawić jej fazy. Z animacji bierzemy tylko czas trwania
 * (prędkość = długość pętli / czas) i nazwę (`prawo` = jedzie w prawo).
 *
 * Przeciąganie: pointer events, więc mysz i palec jedną ścieżką.
 * `touch-action: pan-y` (custom-markiza.css) zostawia przeglądarce
 * pionowe przewijanie strony, a poziomy ruch trafia do nas. Po puszczeniu
 * pas jedzie z prędkością ręki, wytraca ją i wraca do tempa z CSS.
 * Kliknięcie po przeciągnięciu (>6 px) jest anulowane, żeby nie otwierać
 * postów przypadkiem.
 *
 * Gdy CSS nie animuje pasa (tkaniny na desktopie, `prefers-reduced-motion`),
 * skrypt się nie wtrąca — sprawdzane też po zmianie rozmiaru okna.
 */
(function () {
  if (window.__markizyStrony) return;
  window.__markizyStrony = true;

  var PROG_KLIKU = 6; // px — poniżej to klik, powyżej przeciągnięcie

  function init(pas) {
    if (pas.__markiza) return;
    var stan = {
      aktywny: false,
      offset: 0, // px, 0..petla; transform = -offset
      petla: 1,
      tempo: 0, // px/s ze stylu (znak = kierunek)
      v: 0, // bieżąca prędkość px/s
      ciagnie: false,
      przeciagnieto: false,
      ostatniX: 0,
      startX: 0,
      ostatniT: 0,
      vReki: 0,
      klatka: 0,
      ostatniaKlatka: 0,
      pointerId: null,
    };
    pas.__markiza = stan;

    function przelicz() {
      // Dwie kopie treści + odstęp między nimi: pętla = połowa + pół odstępu
      var cs = getComputedStyle(pas);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      stan.petla = Math.max(1, pas.scrollWidth / 2 + gap / 2);
    }

    function sprawdz() {
      // Czytamy animację z CSS, chwilowo zdejmując nasze inline `none`
      pas.style.animation = '';
      var cs = getComputedStyle(pas);
      var nazwa = (cs.animationName || 'none').split(',')[0].trim();
      var czas = parseFloat(cs.animationDuration) || 0;
      var powinien = nazwa !== 'none' && czas > 0;
      if (powinien) {
        pas.style.animation = 'none';
        przelicz();
        var znak = /prawo/i.test(nazwa) ? -1 : 1;
        stan.tempo = (znak * stan.petla) / czas;
        if (!stan.aktywny) {
          stan.aktywny = true;
          stan.v = stan.tempo;
          if (znak < 0) stan.offset = stan.petla - 0.01;
          stan.ostatniaKlatka = 0;
          stan.klatka = requestAnimationFrame(krok);
        }
      } else if (stan.aktywny) {
        stan.aktywny = false;
        cancelAnimationFrame(stan.klatka);
        pas.style.transform = '';
      }
    }

    function rysuj() {
      pas.style.transform = 'translate3d(' + -stan.offset + 'px,0,0)';
    }

    function krok(t) {
      if (!stan.aktywny) return;
      if (stan.ostatniaKlatka) {
        var dt = Math.min(0.1, (t - stan.ostatniaKlatka) / 1000);
        if (!stan.ciagnie) {
          // Fokus z klawiatury w środku pasa = pauza (bez tego link ucieka)
          var cel = pas.contains(document.activeElement) ? 0 : stan.tempo;
          // Po puszczeniu: prędkość ręki wygasa wykładniczo do tempa z CSS
          stan.v = cel + (stan.v - cel) * Math.exp(-dt * 2.2);
          stan.offset += stan.v * dt;
          stan.offset = ((stan.offset % stan.petla) + stan.petla) % stan.petla;
          rysuj();
        }
      }
      stan.ostatniaKlatka = t;
      stan.klatka = requestAnimationFrame(krok);
    }

    function naDol(e) {
      if (!stan.aktywny || e.button > 0) return;
      stan.ciagnie = true;
      stan.przeciagnieto = false;
      stan.startX = stan.ostatniX = e.clientX;
      stan.ostatniT = performance.now();
      stan.vReki = 0;
      stan.pointerId = e.pointerId;
      pas.classList.add('jest-ciagniety');
      // BEZ setPointerCapture: przechwycenie wskaźnika sprawia, że `click`
      // trafia w pas zamiast w link pod kursorem i posty się nie otwierały
      // (2026-09-16). Ruch i puszczenie łapiemy na oknie.
      window.addEventListener('pointermove', naRuch);
      window.addEventListener('pointerup', naGore);
      window.addEventListener('pointercancel', naGore);
    }

    function naRuch(e) {
      if (!stan.ciagnie || e.pointerId !== stan.pointerId) return;
      var teraz = performance.now();
      var dx = e.clientX - stan.ostatniX;
      var dtr = Math.max(1, teraz - stan.ostatniT) / 1000;
      stan.vReki = -dx / dtr; // ciągnięcie w lewo = treść jedzie w lewo = offset rośnie
      stan.offset = (((stan.offset - dx) % stan.petla) + stan.petla) % stan.petla;
      stan.ostatniX = e.clientX;
      stan.ostatniT = teraz;
      if (Math.abs(e.clientX - stan.startX) > PROG_KLIKU) stan.przeciagnieto = true;
      rysuj();
    }

    function naGore(e) {
      if (!stan.ciagnie || (e && e.pointerId !== stan.pointerId)) return;
      stan.ciagnie = false;
      pas.classList.remove('jest-ciagniety');
      window.removeEventListener('pointermove', naRuch);
      window.removeEventListener('pointerup', naGore);
      window.removeEventListener('pointercancel', naGore);
      // Ręka puszczona chwilę temu = bez bezwładności; szybki gest = rozpęd,
      // ale ograniczony, żeby jeden zamach nie przewijał pół pętli
      var swiezy = performance.now() - stan.ostatniT < 80;
      var limit = Math.max(Math.abs(stan.tempo) * 12, 900);
      stan.v = swiezy ? Math.max(-limit, Math.min(limit, stan.vReki)) : stan.tempo;
    }

    pas.addEventListener('pointerdown', naDol);
    // Po przeciągnięciu klik w link nie ma się wykonać
    pas.addEventListener(
      'click',
      function (e) {
        if (stan.przeciagnieto) {
          e.preventDefault();
          e.stopPropagation();
          stan.przeciagnieto = false;
        }
      },
      true
    );
    pas.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    // Szerokość pasa zmienia się, gdy dociągną się zdjęcia (kształt kafli
    // w galerii dokłada JS po wczytaniu) — odświeżamy pętlę bez kosztu
    var obrazki = pas.querySelectorAll('img');
    for (var i = 0; i < obrazki.length; i++) {
      obrazki[i].addEventListener('load', przelicz, { once: true });
    }
    var czekaResize = 0;
    window.addEventListener('resize', function () {
      clearTimeout(czekaResize);
      czekaResize = setTimeout(sprawdz, 150);
    });

    sprawdz();
  }

  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var pasy = document.querySelectorAll('[data-markiza]');
    for (var i = 0; i < pasy.length; i++) init(pasy[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
